/**
 * Created by Victor Rojo on 11/2/19.
 */
import { Component, ViewChild, ElementRef, AfterContentInit, OnDestroy }     from '@angular/core';
import { DomSanitizer, SafeUrl} from '@angular/platform-browser';

import { NgxGalleryOptions, NgxGalleryImage, NgxGalleryAnimation, NgxGalleryImageSize, NgxGalleryLayout } from 'ngx-gallery';

import {Globals} from "../../globals";
import {IPetrolDemoService} from "./IPetrolDemo.service";

@Component({
  templateUrl: './Recordings.component.html',
  styleUrls: ['./Recordings.component.css']
})
export class RecordingsComponent {

  @ViewChild('form', { static: true }) form: ElementRef;
  @ViewChild('XML', { static: true }) XML: ElementRef;
  @ViewChild('ACTION', { static: true }) ACTION: ElementRef;
  @ViewChild('LA', { static: true }) LA: ElementRef;

  private promise: Promise<any>;
  private formUpdated = false;
  isLoading = false;
  private firstLoad = false;
  url: SafeUrl;
  private submited = false;

  galleryImages: any;
  galleryOptions: any;
  image = "assets/images/mock_menus/Grabaciones2.jpg";
  showAsThumbnail = true;
  mock = true;

  constructor(
    private sanitizer: DomSanitizer,
    private iPetrolDemoService: IPetrolDemoService,
    private globals: Globals) {
    this.galleryOptions = [
      {
        width: '300px',
        height: '330px',
        preview: true,
        layout: NgxGalleryLayout.ThumbnailsBottom,
        image: false,
        thumbnailSize: NgxGalleryImageSize.Contain,
        previewCloseOnEsc: true,
        previewCloseOnClick: true,
        thumbnails: true,
        previewFullscreen: true,
        previewZoom:true,
        thumbnailsColumns: 1

      }
    ];

    if ( globals.tenant == "ecuador" || globals.tenant == "demoipetrol" || globals.tenant == "ask") {
      this.showAsThumbnail = false;
    }

    if ( globals.tenant == "demoipetrol" || globals.tenant == "ask" ) {
      this.url = this.sanitizer.bypassSecurityTrustResourceUrl("https://demoipetrol.conexiona.com:26431");
      this.mock = false;
      this.isLoading = true;
      this.promise = this.iPetrolDemoService.getCredentials();
      this.waitForData();
    }

    this.setImage();

    this.galleryImages = [{
      small: this.image,
      medium: this.image,
      big: this.image
    }];
  }

  private setImage(){
    switch (this.globals.tenant){
      case "":
        break;
      case "demoipetrol":
        break;
      case "galp":
        break;
      case "ask":
        this.image = "assets/images/mock_menus/ask/GrabacionesAsk.png";
        break;
      case "ecomanager":
        this.image = "assets/images/mock_menus/ecomotica/grabacionesEco.png";
        break;
      case "hiotera":
        this.image = "assets/images/mock_menus/ecomotica/recordings.png";
        break;
      case "nacexa":
        break;

    }
  }

  waitForData(){
    setTimeout(()=>{
      if ( this.formUpdated ) {
        this.form.nativeElement.submit();
        this.submited = true;
      } else {
        this.waitForData();
      }
    }, 200);
  }

  ngAfterContentInit(){
    if ( this.promise ) {
      this.promise.then( credentials => {
        let token = JSON.parse(credentials.token);
        if ( token.txtUsername && token.txtPassword) {
          this.ACTION.nativeElement.value = "LOGIN";
          this.XML.nativeElement.value = "<user><name>" + token.txtUsername + "</name><password>" + token.txtPassword + "</password></user>";
          this.LA.nativeElement.value = "_ES";
        }
        this.formUpdated = true;
      })
    }
  }

  onLoad(){
    if ( !this.firstLoad ) {
      this.firstLoad = true;
    } else if ( this.submited ) {
      this.url = this.sanitizer.bypassSecurityTrustResourceUrl("https://demoipetrol.conexiona.com:26431/index.jsp");
      this.submited = false;
    } else {
      this.isLoading = false;
    }
  }

  public ngOnDestroy(): void {
    this.ACTION.nativeElement.value = "LOGOUT";
    this.XML.nativeElement.value = "";
    this.LA.nativeElement.value = "";
    this.form.nativeElement.submit();
    this.url = null;
  }
}
